
import axios from 'axios'
import PayloadDetail from '../components/PayloadDetail.vue'
import PayloadComposition from '../components/PayloadComposition.vue'
import { Payload } from '../services/payload'
import { defineComponent } from 'vue'
import { ZipFile } from '@/services/trim_zip'

export default defineComponent({
  components: {
    PayloadDetail,
    PayloadComposition
  },
  data() {
    return {
      zipFile: null,
      payload: null
    } as {
      zipFile: ZipFile | null
      payload: Payload | null
    }
  },
  async created() {
    // put cf_x86_demo.zip and cf_x86_target_file_demo into
    // this directory: /public/files
    try {
      const download = await axios.get('./files/cf_x86_demo.zip', {
        responseType: 'blob'
      })
      this.zipFile = new ZipFile(new File([download.data], 'ota_demo.zip'))
      this.payload = new Payload(this.zipFile as ZipFile)
      await this.payload.init()
    } catch (err) {
      console.log('Please put a proper example OTA in /public/files/')
    }
  }
})
